import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) {}

  showErrorMessages(messages: string[]): void {
    messages.forEach(message => {
      this.toastr.error(message);
    });
  }

  showSuccessMessage(message: string): void {
    this.toastr.success(message);
  }

  showErrorMessage(message: string): void {
    this.toastr.error(message);
  }

  showInfoMessage(message: string): void {
    this.toastr.info(message);
  }

  showWarningMessage(message: string): void {
    this.toastr.warning(message);
  }
}
